<!--
    用法：
        1.导入组件 import Paging from '../common/Paging';
        2.注册组件 components:{Paging}
        3.页面引入 <paging :pageInfo="pageInfo"  @goto="gotoPage"></paging>
        4.父组件需在data中定义pageInfo,然后将response中相关页数信息存入（注意字段），以下为必传信息
            let pageInfo = {};
            pageInfo.pageNumber = response.data.datas.pageNumber;
            pageInfo.totalPage = response.data.datas.totalPage;
            pageInfo.totalRow = response.data.datas.totalRow;
            this.pageInfo = pageInfo;
        5.父组件在methods中定义
            gotoPage (pagingRes) {
                console.log(pagingRes); //用户点击的页数
            }
 -->
<template>
  <div class="page-box" v-if="pageInfo.totalRow">
    <div class="page-goto-box">
      <!--<span>共有{{this.pageInfo.totalPage}}页 ，</span>-->
      <span>跳转到</span>
      <input type="text" v-model="inputPage" @input="changeInputPage" style="padding: 0"/>
      <span class="page-go" @click="changePage(inputPage)">Go</span>
    </div>
    <div class="page-change-box" :title="pageUpdate">
      <!--<span class="page-first page-pos" @click="firstPage()">  </span>-->
      <span class="page-pre page-pos" @click="changePage(pageNo - 1)">&nbsp;</span>
      <!--<div :style="{width:showNumberLength}">-->
      <div :style="{width:pageEllipsis.numberLength + 'px'}">
        <!--<div class="page-long" :style="{width: 35 * pageInfo.totalPage + 'px'}">-->
        <span v-if="pageInfo.totalPage > 0"
          class="page-pos" :class="{active: 1==pageInfo.pageNumber}" @click="changePage(1)">1</span>
        <span v-if="pageEllipsis.front" class="page-ellipsis">...</span>

        <div class="page-long">
          <!--<span :class="{'page-pos':true, active:index+1==pageInfo.pageNumber}" v-for="(item, index) in pageInfo.totalPage"-->
          <!--@click="changePage(index+1)"-->
          <!--&gt;{{index+1}}</span>-->
          <span :class="{'page-pos':true, active:item==pageInfo.pageNumber}"
                v-for="(item, index) in pageEllipsis.showPages"
                @click="changePage(item)"
          >{{item}}</span>

        </div>
        <span v-if="pageEllipsis.back" class="page-ellipsis">...</span>

        <span class="page-pos"
              v-if="pageInfo.totalPage > 1"
              :class="{active: pageInfo.totalPage==pageInfo.pageNumber}"
              @click="changePage(pageInfo.totalPage)">{{pageInfo.totalPage}}</span>
      </div>
      <span class="page-next page-pos" @click="changePage(pageNo + 1)">&nbsp;</span>
      <!--<span class="page-last page-pos" @click="lastPage()">  </span>-->
    </div>
    <div class="page-total-box">
      <p>每页显示
        <select v-model="pageInfo.pageSize"
                @change="changeShowRows">
          <option v-for="item in options" :value="item.value">{{ item.name }}</option>
        </select>
        条&nbsp;&nbsp;|
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Paging',
    props: ['pageInfo', 'isAsync'],
    data () {
      return {
        isShowPage: true,
        inputPage: '',
        leftOffset: 0,
        pageNo: 1,
        showNumberLength: 0,
        showRows: this.pageInfo.pageSize,
        pagingRes: {
          pageNumber: 1,
          pageSize: 10
        },
        hasChanged: false,
        log: '',
        options: [
          {value: 10, name: 10},
          {value: 30, name: 30},
          {value: 50, name: 50},
          {value: 100, name: 100},
          {value: 150, name: 150},
          {value: 200, name: 200},
        ],
        pageEllipsis: {
          front: false,
          back: false,
          showFront: false,
          showBack: false,
          centerNumber: 3,
          showPages: [],
          numberLength: 0
        }
      }
    },
    mounted () {
      this.init();
      this.log = console.log.bind(console)
      // this.log("当前是第几页：", this.pageInfo.pageNumber)
      // this.log("当前需要显示多少条：", this.pageInfo.pageSize)
      // this.log("select、每页显示多少条：", this.showRows)
    },
    methods: {
      init () {
        this.pageInfo.totalPage = this.pageInfo.totalPage || 1;
        this.pageNo = this.pageInfo.pageNumber;
        let offset = 0;
        let pageNumber = this.pageInfo.pageNumber;
        let totalPage = this.pageInfo.totalPage;
        let pageEllipsis = this.pageEllipsis;
        let i;
        pageEllipsis.showPages = [];
        let ellipsisLength = 0;
        if (totalPage > (this.pageEllipsis.centerNumber + 2)) { //需要显示省略号时
//                pageEllipsis.front = true;
//                pageEllipsis.back = true;
//                pageEllipsis.showBack = true;

          if (pageNumber <= (pageEllipsis.centerNumber - 1) / 2 + 2) { //当前页在前几页时
            pageEllipsis.front = false;
            pageEllipsis.back = true;
            ellipsisLength = 30;
            i = 2;
            for (; i <= pageEllipsis.centerNumber+1; i++) {
              pageEllipsis.showPages.push(i);
            }
//            console.log(pageEllipsis.showPages);
          } else if (pageNumber > totalPage - ((pageEllipsis.centerNumber - 1) / 2 + 2)) {//当前页在最后几页时
            pageEllipsis.front = true;
            pageEllipsis.back = false;
            ellipsisLength = 30;
            let startPage  = totalPage - (pageEllipsis.centerNumber - 1) / 2 - 2;
            i = 0;
            for (; i < pageEllipsis.centerNumber; i++) {
              pageEllipsis.showPages.push(startPage + i);
            }
          } else {  //当前页在中间时
            pageEllipsis.front = true;
            pageEllipsis.back = true;
            ellipsisLength = 60;
            pageEllipsis.showPages = [pageNumber - 1, pageNumber, pageNumber + 1];
          }
        } else {   //不需要显示省略号时
          pageEllipsis.front = false;
          pageEllipsis.back = false;
          ellipsisLength = 0;
          if(totalPage > 2){
            i = 0;
            let startPage = 2;
            for (; i < totalPage - 2; i++) {
              pageEllipsis.showPages.push(startPage + i);
            }
          }

        }

        let totalLength = totalPage < 2 ? (1 + pageEllipsis.showPages.length) : (2 + pageEllipsis.showPages.length);
//        console.log('totalLength: ', totalPage);
//        console.log('totalLength: ', pageEllipsis.showPages.length);
//        console.log('totalLength: ', totalLength);
        pageEllipsis.numberLength = ellipsisLength + 32 * totalLength;
//              if(totalPage > (this.pageEllipsis.centerNumber + 2)){
////                pageEllipsis.front = true;
////                pageEllipsis.back = true;
////                pageEllipsis.showBack = true;
//
//                if(pageNumber <= (pageEllipsis.centerNumber-1)/2 + 2){
//                  pageEllipsis.front = false;
//                  pageEllipsis.back = true;
//                  i = 2;
//                  for(; i <= pageEllipsis.centerNumber; i++){
//                    pageEllipsis.showPages.push(i);
//                  }
//                }else if(pageNumber >= totalPage - (pageEllipsis.centerNumber-1)/2 + 2){
//                  pageEllipsis.front = true;
//                  pageEllipsis.back = false;
//                  i = totalPage - (pageEllipsis.centerNumber-1)/2;
//                  for(; i <= pageEllipsis.centerNumber; i++){
//                    pageEllipsis.showPages.push(i);
//                  }
//                }else{
//                  pageEllipsis.front = true;
//                  pageEllipsis.back = true;
//                  pageEllipsis.showPages = [pageNumber - 1, pageNumber, pageNumber + 2];
//                }
//              }else{
//                pageEllipsis.front = false;
//                pageEllipsis.back = false;
//                i = 2;
//                for(; i <= pageEllipsis.centerNumber; i++){
//                  pageEllipsis.showPages.push(i);
//                }
//              }


//              if(this.pageInfo.pageNumber > 2){
//                if(this.pageInfo.pageNumber + 1 <= this.pageInfo.totalPage){
//                  offset = -(32 * (this.pageInfo.pageNumber - 2)) + 'px';
//                }else{
//                  offset = -(32 * (this.pageInfo.pageNumber - 3)) + 'px';
//                }
//              }else{
//                offset = 0;
//              }
//        this.showNumberLength = 32 * (this.pageInfo.totalPage >= 3 ? 3 : this.pageInfo.totalPage) + 'px';
        // console.log('offset: ', offset);
//              this.leftOffset = offset;

//                this.pageNo = this.pageInfo.pageNumber;
        // this.showRows = this.pageInfo.pageSize;
        // console.log('this.pageNo:', this.pageNo)
//                let offset = 0
//                let totalPage = this.pageInfo.totalPage;
//                let pageEllipsis = this.pageEllipsis;
//                if(totalPage > (this.pageEllipsis.centerNumber + 2)){
//                    pageEllipsis.front = true;
//                    pageEllipsis.back = true;
//                }
//
//
//                if(this.pageInfo.pageNumber > 2){
//                    if(this.pageInfo.pageNumber + 1 <= this.pageInfo.totalPage){
//                      offset = -(32 * (this.pageInfo.pageNumber - 2)) + 'px';
//                    }else{
//                      offset = -(32 * (this.pageInfo.pageNumber - 3)) + 'px';
//                    }
//                }else{
//                    offset = 0;
//                }
//              this.showNumberLength = 32 * (this.pageInfo.totalPage >= 3 ? 3 : this.pageInfo.totalPage) + 'px';
//                // console.log('offset: ', offset);
//                this.leftOffset = offset;
        // console.log(offset);
        // console.log(this.pageNo);
      },
      changePage(activeNum){
        activeNum = parseInt(activeNum);
        // this.log(activeNum)
        // this.log("当前页显示多少条：", this.pageInfo.pageSize)
        if (activeNum < 1 || activeNum > this.pageInfo.totalPage) {
          return;
        }
        if (activeNum) {
          this.pageNo = activeNum;
        }
        this.pagingRes.pageNumber = this.pageNo;
        // 修改BUG：IU-798
        this.pagingRes.pageSize = this.pageInfo.pageSize;
        // 原始代码
        // this.pagingRes.pageSize = parseInt(this.showRows);
        this.emitGoto();
        this.inputPage = '';
      },
      changeInputPage () {
        this.inputPage = parseInt(this.inputPage)
        if (!this.inputPage || this.inputPage > this.pageInfo.totalPage || this.inputPage < 1) {
          this.inputPage = '';
        }
      },
      changeShowRows () {
        this.pagingRes.pageNumber = 1;
        // this.pagingRes.pageSize = parseInt(this.showRows);
        this.pagingRes.pageSize = this.pageInfo.pageSize;
        this.emitGoto();
        // this.log("当前是第几页：", this.pageInfo.pageNumber)
        // this.log("当前需要显示多少条：", this.pageInfo.pageSize)
        // this.log("每页显示多少条：", this.showRows)
      },
      emitGoto () {
        if (this.isAsync) {
          let query = this.$router.history.current.query;
          let path = this.$router.history.current.path;
          let newQuery = {};
          if (!query.pageNumber) {
            newQuery['pageNumber'] = this.pagingRes.pageNumber;
          }
          if (!query.pageSize) {
            newQuery['pageSize'] = this.pagingRes.pageSize;
          }

          for (let key in query) {
            if (key == 'pageNumber') {
              newQuery[key] = this.pagingRes.pageNumber;
            } else if (key == 'pageSize') {
              newQuery[key] = this.pagingRes.pageSize;
            } else {
              newQuery[key] = query[key];
            }
          }
          this.$router.push({path, query: newQuery});
        } else {
          // this.log('每次请求数据balbalbal')
          this.$emit('goto', this.pagingRes);
        }
        // this.log("子组件内的pagingRes.pageSize:", this.pagingRes.pageSize)
        // this.log("子组件内的pagingRes.PageNumber:", this.pagingRes.pageNumber)
        // this.log("子组件内的pageInfo.pageSize:", this.pageInfo.pageSize)
        // this.log("子组件内的pageInfo.PageNumber:", this.pageInfo.pageNumber)
      },
      lastPage () {
        if (this.pageInfo.totalPage > 1) {
          this.pagingRes.pageNumber = this.pageInfo.totalPage
          // this.log(this.pagingRes.pageNumber)
          this.pagingRes.pageSize = this.pageInfo.pageSize
          this.emitGoto()
        }
      },
      firstPage () {
        if (this.pageInfo.totalPage > 1) {
          this.pagingRes.pageNumber = 1
          // this.log(this.pagingRes.pageNumber)
          this.pagingRes.pageSize = this.pageInfo.pageSize
          this.emitGoto()
        }
      }
    },
    computed: {
      getShowNumLength(){
        // console.log('totalpage:', this.pageInfo);
      },
      pageUpdate () {
        this.init();
        //  // this.init();
        //  // return this.pageInfo.pageNumber;
      }
    },
    watch: {
      '$route'(to, from){
        this.hasChanged = true;
      }
    }
  }
</script>

<style scoped>
  .page-box {
    /*max-width: 512px;*/
    color: #999;
    font-size: 14px;
    line-height: 22px;
    height: 24px;
    overflow: hidden;
  }

  /*右*/
  .page-goto-box {
    float: right;
    height: 22px;
    margin-left: 5px;
  }

  .page-goto-box span {
    float: left;
    height: 22px;
  }

  .page-goto-box input {
    float: left;
    width: 25px;
    height: 22px;
    border: 1px solid #bfbfbf;
    border-radius: 2px;
    margin-left: 9px;
    text-align: center;
  }

  .page-goto-box .page-go {
    float: left;
    width: 25px;
    height: 100%;
    color: #fff;
    text-align: center;
    line-height: 22px;
    border-radius: 2px;
    background-color: #bd4351;
    margin-left: 9px;
    cursor: pointer;
  }

  /*中*/
  .page-change-box {
    float: right;
  }

  .page-change-box > div {
    float: left;
    height: 22px;
    overflow: hidden;
    position: relative;
  }

  .page-long {
    /*position: absolute;*/
    float: left;
  }

  .page-change-box .page-pos {
    float: left;
    width: 30px;
    height: 22px;
    cursor: pointer;
    text-align: center;
    line-height: 22px;
    border: 1px solid #bfbfbf;
    /*border-radius: 2px;*/
    margin: 0 1px;
  }

  .page-change-box .page-pre {
    background: url('../../assets/images/common/page_pre.png') no-repeat center;
  }

  .page-change-box .page-next {
    background: url('../../assets/images/common/page_next.png') no-repeat center;
  }

  .page-change-box .page-first {
    background: url(../../assets/images/common/newPre.png) no-repeat center;
  }

  .page-change-box .page-last {
    background: url(../../assets/images/common/newNext.png) no-repeat center;
  }

  .page-change-box .active {
    color: #bd4351;
    border-color: #bd4351;
  }

  .page-change-box .page-ellipsis {
    float: left;
    width: 30px;
    height: 22px;
    text-align: center;
  }

  /*.page-change-box > div{
      overflow: hidden;
  }*/
  .page-change-box .page-detail-wrap {
    height: 22px;
    float: left;
    position: relative;
    overflow: hidden;
  }

  .page-detail-wrap1 {
    width: 35px;
  }

  .page-detail-wrap2 {
    width: 70px;
  }

  .page-detail-wrap3 {
    width: 105px;
  }

  .page-change-box .page-detail-wrap .page-long {
    position: absolute;
    left: 0;
    top: 0;
  }

  /*左*/
  .page-total-box {
    float: right;
    margin-right: 5px;
  }

  .page-total-box select {
    border: solid 1px #d6d6d6;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -o-appearance: none;
    font-size: 12px;
    width: 44px;
    height: 22px;
    background: url(../../assets/images/common/pullpage.png) no-repeat scroll right center transparent;
    outline: none;
    border-radius: 2px;
    padding-left: 5px;
  }

  .page-total-box select::-ms-expand {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// PagingPersonal.vue?6ec7085a